// extracted by mini-css-extract-plugin
export default {"root":"SubscriptionPrice_root__kaClv","price":"SubscriptionPrice_price__vJ+s-","duration":"SubscriptionPrice_duration__mf39Q"};